// extracted by mini-css-extract-plugin
export default {"tableRow":"BrowseWorkOrdersPage_tableRow__zwoe0","modalWidth":"BrowseWorkOrdersPage_modalWidth__roF1d","modalHeight":"BrowseWorkOrdersPage_modalHeight__MSN6g"};